var map = {
	"./autumn/common.jpg": 40,
	"./autumn/legendary.jpg": 41,
	"./autumn/viperepic.jpg": 42,
	"./autumn/viperrare.jpg": 43,
	"./autumn/viperunique.jpg": 44,
	"./common.jpg": 45,
	"./legendary.jpg": 46,
	"./spring/common.jpg": 47,
	"./spring/legendary.jpg": 48,
	"./spring/viperepic.jpg": 49,
	"./spring/viperrare.jpg": 50,
	"./spring/viperunique.jpg": 51,
	"./summer/common.jpg": 52,
	"./summer/legendary.jpg": 53,
	"./summer/viperepic.jpg": 54,
	"./summer/viperrare.jpg": 55,
	"./summer/viperunique.jpg": 56,
	"./viperepic.jpg": 57,
	"./viperrare.jpg": 58,
	"./viperunique.jpg": 59,
	"./winter/common.jpg": 60,
	"./winter/legendary.jpg": 61,
	"./winter/viperepic.jpg": 62,
	"./winter/viperrare.jpg": 63,
	"./winter/viperunique.jpg": 64
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14;